import { z } from "zod";

/**
 * Shape of the runtime environment injected as `window.__JUISCI_ENV__`.
 *
 * Producers (single script tag with id "juisci-env" in index.html <head>):
 * - deployed: apps/api front-serve replaces the tag at boot with the values
 *   from its checked-in per-env config (front-config.ts)
 * - `vite dev` / local builds: plugins/inject-env.ts fills it from .env
 *
 * Kept separate from env.ts so the vite plugin (node context, no `window`)
 * can import the schema for type-safe construction.
 */
export const webappEnvSchema = z.object({
  appEnv: z.enum(["production", "staging", "development"]),
  apiUrl: z.string().min(1),
  firebaseApiKey: z.string().min(1),
  firebaseProjectId: z.string().min(1),
  firebaseMessagingSenderId: z.string().min(1),
  firebaseAppId: z.string().min(1),
  // null = feature unset (analytics/push/embeds degrade gracefully).
  firebaseMeasurementId: z.string().min(1).nullable(),
  firebaseVapidKey: z.string().min(1).nullable(),
  redirectMeasurementId: z.string().min(1).nullable(),
  gtmId: z.string().min(1).nullable(),
  mixpanelToken: z.string().min(1).nullable(),
  figmaClientId: z.string().min(1).nullable(),
});

export type WebappEnv = z.infer<typeof webappEnvSchema>;

declare global {
  interface Window {
    __JUISCI_ENV__: unknown;
  }
}
